const BackIcon: React.FC = () => {
    return (
        <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.1143 19.5128L15.1143 1.4872L1.41239 10.5L15.1143 19.5128ZM16.3076 19.9708C16.3076 20.7733 15.4913 21.2661 14.8552 20.8476L0.456895 11.3768C-0.152236 10.9761 -0.152234 10.0239 0.456897 9.62321L14.8552 0.152371C15.4913 -0.266062 16.3076 0.226717 16.3076 1.02916L16.3076 19.9708Z"
                fill="white"
            />
        </svg>
    )
}

BackIcon.displayName = 'BackIcon'

export default BackIcon
